import React from 'react';

export const LazyMdmDeviceListPage = React.lazy(() => import('./MdmDeviceListPage'));
